// extracted by mini-css-extract-plugin
module.exports = {"root":"a10a3f92e9--root--2_FYT","amenity-list":"a10a3f92e9--amenity-list--_eOMN","amenity":"a10a3f92e9--amenity--yyYUB"};